import React from 'react'
import {connect} from "react-redux";
import PropTypes from 'prop-types'

import KeywordSearchControl from './Controls/KeywordSearchControl.js'
import FilterToggleControl from './Controls/FilterToggleControl.js'
import ModalLinkControl from './Controls/ModalLinkControl.js'
import ControlBar from './Controls/ControlBar.js'

import LanguageBlock from './NaturalLanguage/LanguageBlock.js'
import Token from './NaturalLanguage/Token.js'
import Modal from './Modals/Modal.js'

import { 
  selectActiveFilters,
  selectActiveSort,
  selectDefaultContext,
  selectTokenGroups,
  selectBarLinks,
  selectDefaultPhrase
} from '../State/selectors.js'

import {
  openModal, 
  initiateKeywordText,
  initiateFetchPostInitData,
  deactivateFilterGroup,
  deactivateAllFilters
} from '../State/actions.js'

const mapStateToProps = (state) => {
  var activeFilters = selectActiveFilters(state)
  var defaultContext = selectDefaultContext(state)
  var tokenGroups = selectTokenGroups(state)
  var barLinks = selectBarLinks(state)
  var activeSort = selectActiveSort(state)
  var defaultPhrase = selectDefaultPhrase(state)

  // eslint-disable-next-line no-console
  // console.log(" [ DEBUG ] TOKEN GROUPS : groups :  ", tokenGroups)

  return { activeFilters, defaultContext, defaultPhrase, tokenGroups, barLinks, activeSort}
}

const actions = {
  openModal,
  initiateKeywordText,
  initiateFetchPostInitData,
  deactivateFilterGroup,
  deactivateAllFilters
}


class SearchController extends React.Component {
  static get propTypes () {
    return {
      activeFilters: PropTypes.array,
      defaultContext: PropTypes.string,
      defaultPhrase: PropTypes.string,
      openModal: PropTypes.func,
      initiateKeywordText: PropTypes.func,
      initiateFetchPostInitData: PropTypes.func,
      tokenGroups: PropTypes.array,
      deactivateFilterGroup: PropTypes.func,
      barLinks: PropTypes.array,
      activeSort: PropTypes.object,
      deactivateAllFilters: PropTypes.func
    }
  }

  UNSAFE_componentWillMount () {
    this.props.initiateKeywordText()
    this.props.initiateFetchPostInitData()
  }

  renderControlBar () {
    var { barLinks } = this.props

    return barLinks.map( conf => {
      if ( conf.action === "keyword" ) {
          return <KeywordSearchControl key={conf.copy} {...conf} />
      }
      else if (conf.action === "open") {
          return <ModalLinkControl key={conf.copy} {...conf} />
      } 
      else {
          return <FilterToggleControl key={conf.copy} {...conf} />
      }
    })
  }

  renderTokens () {
    /* For each tokenGroup output a token */
    const { 
      defaultContext, defaultPhrase, tokenGroups, openModal, 
      deactivateFilterGroup, activeSort 
    } = this.props

    const renderDefault = ( tokenGroups.length === 0 ||
      (tokenGroups.length > 0 && tokenGroups[0].context !== defaultContext) )

    const tokens = tokenGroups.map((tokenGroup, i) => {
      var text = tokenGroup.filters.reduce( (acc, f) => 
        acc.concat([f.name]), []
      ).join(", ")

      var preposition = !renderDefault && i === 0 ? "Showing" : tokenGroup.preposition

      return (
        <Token key={tokenGroup.paramName}
          preposition={preposition}
          text={text}
          label={tokenGroup.paramName}
          mainClick={() => { openModal(tokenGroup.context) }}
          secondaryClick={() => { deactivateFilterGroup( tokenGroup.paramName ) }}
        />
      )
    })

    if ( renderDefault ) {
      tokens.unshift(
        <Token key={"default"}
          preposition={"Showing"}
          text={defaultPhrase}
          isPlaceholder={true}
          mainClick={() => { openModal(defaultContext) }}
        />
      )
    }

    tokens.push(
      <Token key={"sort"}
        preposition={"sorted by"}
        text={activeSort.name}
        isPlaceholder={true}
        mainClick={() => { openModal("sort") }}
        secondaryClick={() => { openModal("sort") }}
      />
    )

    return tokens
  }

  render () {
    return (

      <div className="SearchController uk-position-relative">

        <ControlBar>
          { this.renderControlBar() } 
        </ControlBar>

        <LanguageBlock>
          { this.renderTokens() } 
        </LanguageBlock>

        { /* Note: modal is rendered with React Portal */ }
        <Modal />

      </div>
    )
  }
}

export default connect(mapStateToProps, actions)(SearchController);
